import React from "react";
import Header from "./Reusables/Header";
import REPHQTable from "./Tables/REPHQTable";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadImg from "../assests/download.svg";
import PeriodSelector from "./PeriodSelector";
const REPHQLevelBudget = () => {




  return (
    <div className="bg-white home-screen">
     
      <PeriodSelector/>
      <REPHQTable style={{ marginTop: "20px", marginRight: "10px" }} />
    
    </div>
  );
};

export default REPHQLevelBudget;
